<template>
  <div>
    <div class="toolbtn flex">
      <switchcore></switchcore>
      <el-tooltip class="item" effect="dark" content="刷新" placement="top">
        <div @click="refresh()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12sx(1).png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">刷新</span>
        </div>
      </el-tooltip>
      <el-tooltip class="item" effect="dark" content="返回" placement="top">
        <callback></callback>
      </el-tooltip>
      <el-tooltip
        class="item"
        effect="dark"
        content="显隐列"
        placement="top"
        v-if="columns"
      >
        <div @click="showColumn()" class="cursorpointer margin-top10">
          <img
            src="@/assets/barsvg/icon／12xsl.png"
            style="position: relative; top: 2px"
            alt=""
          />
          <span class="f12 pad-left5" style="color: #969eac">显隐列</span>
        </div>
      </el-tooltip>
    </div>
    <!-- 关键词检索  -->
    <div
      class="backwhite border-rd3 flexleft"
      style="min-height: 168px"
      v-if="serchkey"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        size="small"
        label-width="100px"
        class="demo-ruleForm width90 flexleft"
      >
        <el-form-item label="费用名称" prop="patentee">
          <el-input
            placeholder="请输入费用名称查询"
            v-model="ruleForm.patentee"
          ></el-input>
        </el-form-item>
        <el-form-item label="费用类型" prop="patent_type">
          <el-select
            v-model="ruleForm.patent_type"
            placeholder="请选择费用类型查询"
            class="width100"
            :filterable="true"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属项目" prop="appNumber">
          <el-select
            v-model="ruleForm.appNumber"
            placeholder="请选择所属项目查询"
            class="width100"
            :filterable="true"
            @change="selctchange"
          >
            <el-option label="---  请选择  ---" value=""></el-option>
            <el-option
              v-for="item in nullcont"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="单据编号" prop="keyword">
          <el-input
            v-model="ruleForm.keyword"
            placeholder="请输入单据编号查询"
          ></el-input>
        </el-form-item>
        <el-form-item label="报销时间" prop="address">
          <el-date-picker
            placeholder="请选择报销时段查询"
            v-model="ruleForm.address"
            :editable="false"
            value-format="yyyy-MM-dd"
            type="daterange"
            style="width: 50%"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="width98 margin-auto margin-top5 flex-betweennowrap pad-bot20">
        <p class="margin-left10">
          <el-button type="primary" @click="submitForm('ruleForm')"
            >检 索</el-button
          >
          <el-button @click="resetForm('ruleForm')" class="resetbtn"
            >重 置</el-button
          >
          <el-button @click="exportForm('ruleForm')">导出</el-button>
          <el-button @click="assistance()" v-if="assistancesf"
            >研发辅助账</el-button
          >
        </p>
      </div>
    </div>

    <el-skeleton
      class="width100 backwhite margin-top15 pad-top20 border-rd3 alldigitaltr"
      :loading="loading"
      animated
      :throttle="500"
      v-if="total != 0"
    >
      <template slot="template">
        <div class="width98 margin-auto backwhite">
          <el-table
            :data="page"
            stripe
            class="eltable width100 margin-auto f14"
          >
            <el-table-column
              label="所属项目"
              align="center"
              prop="project.title"
              v-if="columns[0].visible"
            />
            <el-table-column
              label="费用分类"
              align="center"
              v-if="columns[1].visible"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.big_class.name }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="费用类型"
              align="center"
              v-if="columns[2].visible"
              width="430px"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.small_class.name }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="金额(元)"
              align="center"
              prop="amount"
              v-if="columns[3].visible"
            />
            <el-table-column
              label="负 责 人"
              align="center"
              prop="project.manager_name"
              v-if="columns[4].visible"
            />
            <el-table-column
              label="报销时间"
              align="center"
              prop="pay_date"
              v-if="columns[5].visible"
            />

            <el-table-column
              label="报 销 人"
              align="center"
              prop="realname"
              v-if="columns[6].visible"
            />
            <el-table-column
              label="状态"
              align="center"
              v-if="columns[7].visible"
            >
              <template slot-scope="scope">
                <span
                  :class="
                    scope.row.check_status == 0
                      ? 'contcolor'
                      : scope.row.check_status == 1
                      ? 'contcolors'
                      : scope.row.check_status == 2
                      ? 'contcolors'
                      : scope.row.check_status == 3
                      ? 'contcolorss'
                      : 'contcolorsss'
                  "
                ></span>
                <span>{{ scope.row.check_status_text }}</span></template
              ></el-table-column
            >
            <el-table-column
              label="操作"
              align="center"
              class-name="small-padding fixed-width"
              v-if="columns[8].visible"
            >
              <template slot-scope="scope">
                <div class="flex cursorpointer">
                  <span style="color: #52c5cb" @click="prepreview(scope.row)"
                    >详情</span
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div
            class="
              flex-betweennowrap
              pad-top20 pad-bot20 pad-left10 pad-right10
            "
            v-if="total != 0"
          >
            <span class="bluecolor f14"></span>
            <el-pagination
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="currentchange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="per_page"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </el-skeleton>
    <div
      class="width100 margin-auto backgroudFFF margin-top15"
      v-if="total == 0"
    >
      <el-empty
        :image="require('@/assets/barsvg/zwsj@3x.png')"
        :image-size="200"
        description="抱歉，没有搜到您想要的内容"
        class="heightempty"
        ><p style="position: relative; bottom: 60px" class="f14">
          暂无数据
        </p></el-empty
      >
    </div>

    <!-- 预览 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleprepreview"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="53%"
      class="errorboxs"
    >
      <aollectionprepreview></aollectionprepreview>
    </el-dialog>
    <!-- 研发辅助账 -->
    <el-dialog
      title=""
      :visible.sync="dialogVisibleassistance"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="70%"
      class="errorboxs"
    >
      <div class="backwhite width98 margin-auto">
        <p class="textalign-left f16">研发辅助账（项目）</p>
        <div class="margin-top30 pad-bot20" id="printTests">
          <div class="textalign-left">
            <div
              class="
                width96
                margin-auto
                backwhite
                margin-top10
                border-rd3
                margin-top40
                posrtionre
              "
              style="border: 2px solid #878787"
              v-for="(item, index) in projectcont"
              :key="index"
            >
              <p class="maincolor margin-top10 margin-bot10 monthcont">
                月份:{{ projectcont[index].list[0].fee_date.substring(0, 7) }}
              </p>
              <!-- 费用名称 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div class="width30" style="height: 150px">
                  <div
                    style="height: 40px; line-height: 40px"
                    class="botborder"
                  >
                    凭证信息
                  </div>
                  <div style="height: 110px" class="flex-betweenNowrapAligns">
                    <div class="width40 textalign-center ritborder botborder">
                      <p class="pad-top30">日期</p>
                    </div>
                    <div class="width60 textalign-center botborder">
                      <p class="pad-top30">种类</p>
                    </div>
                  </div>
                </div>
                <div class="width70" style="height: 150px">
                  <div class="flex-betweenwrap width100">
                    <div
                      class="width100 heitlinhet botborder leftborder"
                      style="height: 40px; line-height: 40px"
                    >
                      费用明细
                    </div>
                    <div
                      class="flex-betweenNowrapAlign botborder"
                      style="height: 109px"
                    >
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">人员人工费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">直接投入费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">折旧费用</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">无形资产摊销</p>
                      </div>
                      <div class="width12 leftborder" style="height: 109px">
                        <p class="pad-top30">新产品设计费等</p>
                      </div>
                      <div
                        class="width12 leftborder ritborder"
                        style="height: 109px"
                      >
                        <p class="pad-top30">其他相关费用</p>
                      </div>
                      <div class="width28" style="height: 109px">
                        <div class="width100 heitlinhet botborder">
                          委托研发费用
                        </div>
                        <div class="flex-aroundnowrapcev">
                          <div class="width50" style="height: 80px">
                            委托境内机构或个人进行研发活动所发生的费用
                          </div>
                          <div class="width50 leftborder" style="height: 80px">
                            委托境外机构进行研发活动所发生的费用
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 费用明细 -->
              <div
                class="
                  width100
                  flex-betweenNowrapAligns
                  textalign-center
                  f12
                  botborder
                "
                v-for="(_item, _index) in item.list"
                :key="_index"
              >
                <div class="width30 heitlinhet flex-betweenNowrapAligns">
                  <div class="width40 textalign-center ritborder">
                    {{ _item.fee_date }}
                  </div>
                  <div class="width60 textalign-center">
                    {{ _item.small_class }}
                  </div>
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 1">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 3">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 10">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 13">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 17">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width12 heitlinhet leftborder">
                    <span v-if="_item.big_class_id == 22">{{
                      _item.amount
                    }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet leftborder"></div>
                    <div class="width50 heitlinhet leftborder">
                      <span v-if="_item.big_class_id == 27">{{
                        _item.amount
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 合计金额 -->
              <div
                class="width100 flex-betweenNowrapAligns textalign-center f12"
              >
                <div
                  class="width30 heitlinhet ritborder"
                  style="padding-right: 1px"
                >
                  合计金额
                </div>
                <div class="flex-betweenNowrapAligns width70 heitlinhet">
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][1] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][3] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][10] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][13] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][17] }}</span>
                  </div>
                  <div class="width12 heitlinhet ritborder">
                    <span>{{ projectSum[index][22] }}</span>
                  </div>
                  <div class="width28 flex-betweenNowrapAligns heitlinhet">
                    <div class="width50 heitlinhet ritborder">0</div>
                    <div class="width50 heitlinhet">
                      <span>{{ projectSum[index][27] }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="textalign-right">
          <el-button type="primary" v-print="'#printTests'">打 印</el-button>
          <el-button @click="dialogVisibleassistance = false">取 消</el-button>
        </p>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog :title="title" :visible.sync="open" append-to-body width="40%">
      <el-transfer
        :titles="['全选', '全选']"
        v-model="value"
        :data="columns"
        @change="dataChange"
      ></el-transfer>
    </el-dialog>
  </div>
</template>
  <script>
import {
  entrdfeefinance,
  entrdfeecate,
  enttechresearchdevelopmentmy,
  entassistrecordindex,
} from "@/api/newhead/newhead.api";

import callback from "@/components/callback.vue";
import switchcore from "@/components/switchcore.vue";
import BUS from "@/BUS/BUS";
import aollectionprepreview from "./financial-preview.vue";
export default {
  data() {
    return {
      loading: true,
      // 显隐数据
      value: [],
      // 弹出层标题
      title: "显示/隐藏",
      // 是否显示弹出层
      open: false,
      errormessage: "",
      dialogVisiblenull: false,
      dialogVisibleprepreview: false,
      dialogVisibleassistance: false,
      ruleForm: {
        patentee: "",
        patent_type: "",
        keyword: "",
        address: "",
        appNumber: "",
      },
      options: [],
      nullcont: [],
      thisNum: 1,
      currentPage: 1,
      page: [],
      total: 0,
      per_page: 0,
      progress: "",
      serchkey: true,
      input: "",
      assistancesf: false,
      projectnumber: "",
      projecttitle: "",
      finish_status: "",
      cwmanger: "",
      manager_name: "",
      assistanvalue: [],
      projectcont: [],
      // projecttitle: "",
      projectSum: [],
      columns: [
        { key: 0, label: `所属项目`, visible: true },
        { key: 1, label: `费用分类`, visible: true },
        { key: 2, label: `费用类型`, visible: true },
        { key: 3, label: `金额`, visible: true },
        { key: 4, label: `负责人`, visible: true },
        { key: 5, label: `保险时间`, visible: true },
        { key: 6, label: `报销人`, visible: true },
        { key: 7, label: `状态`, visible: true },
        { key: 8, label: `操作`, visible: true },
      ],
    };
  },

  components: {
    callback,
    switchcore,
    aollectionprepreview,
  },

  methods: {
    // 右侧列表元素变化
    dataChange(data) {
      for (let item in this.columns) {
        const key = this.columns[item].key;
        this.columns[item].visible = !data.includes(key);
      }
    },
    // 打开显隐列dialog
    showColumn() {
      this.open = true;
    },
    selctchange(value) {
      entassistrecordindex({
        project_id: value,
        method: "by_project",
      }).then((res) => {
        if (res.data.code == 200) {
          this.assistancesf = true;
          this.projectcont = Object.values(res.data.data);
          let obj = { ...res.data.data };
          for (let k in obj) {
            const Sum = obj[k].list.reduce((prev, { big_class_id, amount }) => {
              return (
                (prev[big_class_id] =
                  (prev[big_class_id] || 0) + Number(amount)),
                prev
              );
            }, {});
            this.projectSum.push(Sum);
          }
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    submitForm(formName) {
      this.assistancesf = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          entrdfeefinance({
            _keywords: this.ruleForm.patentee, //名称
            serial: this.ruleForm.keyword,
            pay_date:
              this.ruleForm.address == ""
                ? ""
                : this.ruleForm.address[0] + " - " + this.ruleForm.address[1],
            category: this.ruleForm.patent_type,
            project_id: this.ruleForm.appNumber,
            // make_rab: 1,
          }).then((res) => {
            if (res.data.code == 200) {
              this.pagination = true;
              this.page = res.data.data.data;
              this.total = res.data.data.total;
              this.per_page = res.data.data.per_page;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          return false;
        }
      });
    },
    assistance() {
      this.dialogVisibleassistance = true;
    },
    exportForm(formName) {
      this.assistancesf = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          entrdfeefinance({
            _keywords: this.ruleForm.patentee, //名称
            serial: this.ruleForm.keyword,
            pay_date:
              this.ruleForm.address == ""
                ? ""
                : this.ruleForm.address[0] + " - " + this.ruleForm.address[1],
            category: this.ruleForm.patent_type,
            project_id: this.ruleForm.appNumber,
            export: 1,
          }).then((res) => {
            if (res.data.code == 200) {
              window.location.href = window.g.Apisrc + res.data.data.url;
            } else {
              this.dialogVisiblenull = true;
              this.errormessage = res.data.msg;
            }
          });
        } else {
          return false;
        }
      });
    },
    // input重 置
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.thisNum = 1;
      this.assistancesf = false;
      entrdfeefinance({
        page: this.thisNum,
      }).then((res) => {
        if (res.data.code == 200) {
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    // 预览
    prepreview(row) {
      this.dialogVisibleprepreview = true;
      window.sessionStorage.setItem("costrowid", row.id);
      BUS.$emit("costrowid", row.id);
    },

    // 第一个分页
    currentchange(val) {
      this.thisNum = val;
      entrdfeefinance({
        page: val,
        _keywords: this.ruleForm.patentee, //名称
        serial: this.ruleForm.keyword,
        pay_date:
          this.ruleForm.address == ""
            ? ""
            : this.ruleForm.address[0] + " - " + this.ruleForm.address[1],
        category: this.ruleForm.patent_type,
        project_id: this.ruleForm.appNumber,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    handleSizeChange(val) {
      entrdfeefinance({
        page: 1,
        limit: val,
        _keywords: this.ruleForm.patentee, //名称
        serial: this.ruleForm.keyword,
        pay_date:
          this.ruleForm.address == ""
            ? ""
            : this.ruleForm.address[0] + " - " + this.ruleForm.address[1],
        category: this.ruleForm.patent_type,
        project_id: this.ruleForm.appNumber,
      }).then((res) => {
        if (res.data.code == 200) {
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    refresh() {
      this.$loading.show(); // 显示loading
      entrdfeefinance({
        page: this.thisNum,
        _keywords: this.ruleForm.patentee, //名称
        serial: this.ruleForm.keyword,
        pay_date:
          this.ruleForm.address == ""
            ? ""
            : this.ruleForm.address[0] + " - " + this.ruleForm.address[1],
        category: this.ruleForm.patent_type,
        project_id: this.ruleForm.appNumber,
      }).then((res) => {
        if (res.data.code == 200) {
          this.$loading.hide(); // 隐藏loading
          this.pagination = true;
          this.page = res.data.data.data;
          this.total = res.data.data.total;
          this.per_page = res.data.data.per_page;
        } else {
          this.$loading.hide(); // 隐藏loading
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
  },
  created() {
    BUS.$on("serchkey", (data) => {
      this.serchkey = data;
    });

    if (window.sessionStorage.getItem("navigetionval") == null) {
      this.thisNum = 1;
      this.currentPage1 = 1;
    } else {
      this.thisNum = window.sessionStorage.getItem("navigetionval");
      this.currentPage1 = parseInt(
        window.sessionStorage.getItem("navigetionval")
      );
    }

    entrdfeefinance({
      page: this.thisNum,
    }).then((res) => {
      if (res.data.code == 200) {
        this.pagination = true;
        this.page = res.data.data.data;
        this.total = res.data.data.total;
        this.per_page = res.data.data.per_page;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 获取研发项目
    enttechresearchdevelopmentmy({ page: this.thisNum }).then((res) => {
      if (res.data.code == 200) {
        this.nullcont = res.data.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    // 分类
    entrdfeecate({}).then((res) => {
      if (res.data.code == 200) {
        this.options = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
  mounted() {
    BUS.$on("financial", (data) => {
      if (data == "yes") {
        this.dialogVisibleprepreview = false;
        this.refresh();
      } else {
        this.dialogVisibleprepreview = false;
      }
    });
  },
};
</script>
  <style scoped>
.maincolor {
  color: #52c5cb;
}
.monthcont {
  position: absolute;
  top: -35px;
}
.contcolor {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #7b83ea;
  position: relative;
  top: -1px;
  right: 5px;
}
.contcolors {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #bfc6d3;
  position: relative;
  top: -1px;
  right: 5px;
}
.contcolorss {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ffc816;
  position: relative;
  top: -1px;
  right: 5px;
}
.contcolorsss {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #52c5cb;
  position: relative;
  top: -1px;
  right: 5px;
}
.el-col-4 {
  width: 26%;
}
.eltable >>> .el-table__header-wrapper th {
  background-color: #f8f8f9;
  height: 40px;
  font-size: 14px;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorboxs >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}

/* 调用window.print()时生效的样式 */
@media print {
  @page {
    /* 横向 */
    /* size: landscape; */
    /* 去除浏览器默认页眉页脚 */
    margin: 0;
  }
  /* 给需要打印的区域内或同级不需要打印的元素加上这个类 */
  .noprint {
    display: none;
  }
  /* 这里的id我用于选中modal，然后给其中背景色设置为透明，去掉弹窗头和脚及阴影 */
  #printTests {
    /* 默认打印内容区背景色*/
    /* -webkit-print-color-adjust: exact; */
    border: solid white !important;
    background-color: #fff !important;
  }
}

/* 需要打印的区域*/
.printable {
  display: block;
}
.invoice {
  width: 100%;
  line-height: 30px;
  border-radius: 3px;
  margin: 20px 0 0 0;
  background: #ecf8f9;
  border: 1px dashed #52c5cb;
}
/* .  {
  border: 1px solid #6e6e6e;
} */
.topborder {
  border-top: 1px solid #6e6e6e;
}
.botborder {
  border-bottom: 1px solid #6e6e6e;
}
.ritborder {
  border-right: 1px solid #6e6e6e;
}
.leftborder {
  border-left: 1px solid #6e6e6e;
}

.heitlinhet {
  min-height: 30px;
  line-height: 30px;
}
</style>